import { markRaw } from 'vue'

const initialState = () => ({
  roles: markRaw([]),
  nodes: markRaw([]),
  rolesByFranchises: null,
  status: [],
  message: ''
})

export default initialState
